import { defineGameCard, onAppear } from '../authoring/index.js';
import { alliedPlants, crown, healUnit, isDamaged, isLiveOnBoard, maturation, photosynthesis, tableOf, } from './plant-helpers.js';
/**
 * Саженец Великого дуба: при раскрытии лечит другие Растения локации; затем
 * Созревание 4 превращает его в Древний дуб 10/12.
 */
export const GreatOakSaplingCard = defineGameCard({
    id: 'great_oak_sapling',
    gameplay: {
        type: 'UNIT',
        cost: 3,
        baseStats: { attack: 0, health: 6 },
        traits: ['PLANT', 'TREE'],
        keywords: ['CANNOT_ATTACK'],
    },
    presentation: {
        name: 'Саженец Великого дуба',
        description: 'При раскрытии другие ваши Растения в этой локации восстанавливают 1 здоровье. Не атакует. Фотосинтез. Крона. Созревание 4: превращается в Древний дуб 10/12.',
        glyph: {
            colors: ['#10213A', '#76A61D', '#5A8422', '#5C5319', '#617744'],
            rows: [
                '.........11.........',
                '........1231........',
                '.......142221.......',
                '....1..123241.11....',
                '...12111443311221...',
                '...12432344423221...',
                '...14224445324321...',
                '...12223212352431...',
                '....113314144211....',
                '.....144141441......',
                '......1114.11.......',
                '.........4..........',
                '.........4..........',
                '.........4..........',
                '.........4..........',
                '.....111145111......',
                '....144444555511....',
                '...14444444445551...',
                '...1444444444441....',
                '....11111111111.....',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onAppear((ctx) => {
            const self = ctx.self;
            if (!isLiveOnBoard(self))
                return;
            for (const plant of alliedPlants(ctx, self.controllerId, {
                tableId: tableOf(self.cellId),
                exclude: new Set([self.id]),
            })) {
                if (isDamaged(ctx, plant.id))
                    healUnit(ctx, plant.id, 1, self.id);
            }
        }, { cause: 'played' }),
        ...photosynthesis(),
        ...crown(),
        maturation('great_oak_sapling', 4, { id: 'ancient_oak', attack: 10, health: 12 }),
    ],
    ui: {
        mechanics: ['cannot_attack', 'growth', 'photosynthesis', 'crown', 'maturation'],
    },
});
//# sourceMappingURL=great_oak_sapling.js.map